export const METADATA_NAMES = {
    organizationType: 'OrganizationType',
    department: 'Department',
    category: 'Category',
    gender: 'Gender',
    ethnicity: 'Ethnicity',
    disability: 'Disability',
    socioEconomicStatus: 'SocioEconomicStatus',
    role: 'Role',
    activityType: 'ActivityType',
    documentTag: 'DocumentTag',
    productionProjectStatus: 'ProductionProjectStatus',
    activityStatus: 'ActivityStatus',
    storageProvider: 'StorageProvider',
    productionSubtype: 'ProductionSubType',
    showType: 'ShowType',
    productionStatus: 'ProductionStatus',
    bookingStatus: 'BookingStatus',
    organizationRole: 'OrganizationRole',
    opportunityStatus: 'OpportunityStatus',
    budgetCategory: 'BudgetCategory',
    financialFact: 'FinancialFact',
    catalogSubType: 'CatalogSubType',
    resourceType: 'ResourceType',
    associatedOrg: 'Organization',
    associatedOrgProductionRole: 'OrganizationRole',
    linkedPerson: 'Person',
    linkedPersonProductionRole: 'Role',
    creativeSubmissionStatus: 'CreativeSubmissionStatus',
    shortlistItemStatus: 'ShortlistItemStatus',
    group: 'ProductionGroups',
    representativesFullName: 'Person',
    keyRoles: 'Role'
};

export const FORM_WIDGET_COMPONENTS = {
    number: 'Number',
    money: 'Money',
    currency: 'Currency',
    textArea: 'TextArea',
    switch: 'Switch',
    autocomplete: 'Autocomplete',
    referenceAutocomplete: 'ReferenceAutocomplete',
    metadataAutocomplete: 'MetadataAutocomplete',
    entityAutocomplete: 'EntityAutocomplete',
    sectionTitle: 'SectionTitle',
    richText: 'RichText',
    attachments: 'Attachments',
    location: 'Location',
    date: 'Date',
    time: 'Time',
    toggleButtonGroup: 'ToggleButtonGroup',
    radiogroup: 'Radiogroup',
    chips: 'Chips',
    buttons: 'Buttons',
    text: 'Text'
};

export const FORM_WIDGET_TYPES = {
    number: 'number'
};

export const DATE_PERIOD = {
    dateRange: 'dateRange',
    durationSpecified: 'durationSpecified'
};

export const FORM_BUTTONS = {
    cancel: 'cancel',
    save: 'save',
    delete: 'delete'
};

export const RADIO_GROUP_DIRECTORY_OPTIONS = {
    includeInquire: 'includeInquire',
    directoryExclude: 'directoryExclude'
};

export const DEFERRED_DATE_EDITING_KEYS = [
    'ArrowUp',
    'ArrowDown',
    'Backspace',
    'Delete',
    'Home',
    'End',
    'PageUp',
    'PageDown'
];
